import { DropdownItem } from '../../models/dropdown-item';
import { Country } from '../../models/common-data/country';
import { State } from '../../models/common-data/state';
import { PioneerUtils } from '../../utils/pioneer-utils';

export class CommonDataMapper {

    static convertCountriesToDropDownItem(countries: Country[]): DropdownItem[] {
        return countries.map(country => CommonDataMapper.convertCountryToDropDownItem(country));
    }

    static convertStatesToDropDownItem(states: State[]): DropdownItem[] {
        return states.map(state => CommonDataMapper.convertStateToDropDownItem(state));
    }

    static convertCountryToDropDownItem(country: Country): DropdownItem {
        return new DropdownItem(PioneerUtils.safeTrim(country.code), PioneerUtils.safeTrim(country.longDescription));
    }

    static convertStateToDropDownItem(state: State): DropdownItem {
        return new DropdownItem(PioneerUtils.safeTrim(state.stateCode), PioneerUtils.safeTrim(state.name));
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/common-data/common-data.mapper.ts